import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'unitConverter',
  standalone: true
})
export class UnitConverter implements PipeTransform {

  transform(value: number, unit: string): string {
    if (value == null)
      return ' /';
    if (value == 0) return '0 k' + unit;

    const number = parseFloat(value.toString().replace(/[^\d.-]/g, ''));

    return this.convert(number, 1000, 'k' + unit);
  }

  private convert(number: number, factor: number, unit: string): string {
    const convertedValue = parseFloat((number / factor).toFixed(4));
    return `${convertedValue} ${unit}`
  }
}
